export const NAME = 'name';
export const OWNER = 'owner';
export const BUSINESS_PARTNER = 'businessPartner';
export const EXPENSE_TYPE = 'expenseType';
export const REVENUE_SHARE = 'revenueShare';
export const ADDITIONAL_FEE = 'additionalFee';
export const ADDITIONAL_FEE_PERIOD = 'period';
export const ADDITIONAL_FEE_PERIOD_FROM = 'from';
export const ADDITIONAL_FEE_PERIOD_TO = 'to';
export const TAX_FEE_PERCENT = 'taxFeePercent';
export const SPEND_SOURCE = 'spendSource';
export const MEDIA_SOURCE = 'mediaSource';

export const TRAFFIC_TYPES = 'trafficTypes';
export const CHANNEL = 'channel';
export const CONTACT_PERSON = 'contactPerson';
export const FIRST_NAME = 'firstName';
export const LAST_NAME = 'lastName';
export const EMAIL = 'email';
export const MOBILE = 'mobile';
export const PHONE = 'phone';
export const SKYPE = 'skype';
export const DYNAMIC_REWARDS_SUPPORT = 'dynamicRewardsSupport';
export const INVOICE_PROCESSING_RULE = 'invoiceProcessingRule';

export const DEPENDENCIES = {
  [EXPENSE_TYPE]: [BUSINESS_PARTNER],
  [INVOICE_PROCESSING_RULE]: [BUSINESS_PARTNER],
};

export const EXPENSE_TYPE_REV_SHARE = 2;

export const NETWORK_WEB = 0;
export const NETWORK_MOBILE = 1;

export const DYNAMIC_REWARDS_SUPPORT_PERMISSION = 54;
